import { Button } from '@repo/shadcn';
import { useFormContext } from 'react-hook-form';

import { CalendarInput } from '@/components/ui/form/inputs/calendar';

export const TransactionFilters = () => {
    const { reset } = useFormContext();

    const handleResetFilter = () => {
        reset();
    };

    return (
        <div className="flex gap-4">
            <div className="flex items-center gap-2">
                <span>From</span>
                <CalendarInput fieldName="from" />
            </div>
            <div className="flex items-center gap-2">
                <span>To</span>
                <CalendarInput fieldName="to" />
            </div>
            <div className="flex items-center gap-2">
                <Button
                    onClick={handleResetFilter}
                    variant="outline"
                    type="button"
                >
                    Reset
                </Button>
            </div>
        </div>
    );
};
